import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
// import BlogHome from "@/components/BlogHome";
// import BlogPost from "@/components/BlogPost";

const routes = [
  {
    path: "/home",
    alias: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/products/automobile",
    name: "automobile",
    // route level code-splitting
    // this generates a separate chunk (automobile.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "automobile" */ "../views/AutomobileView.vue"
      ),
  },
  {
    path: "/products/industrial",
    name: "industrial",
    // route level code-splitting
    // this generates a separate chunk (industrial.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "industrial" */ "../views/IndustrialView.vue"
      ),
  },
  {
    path: "/products/greases",
    name: "greases",
    // route level code-splitting
    // this generates a separate chunk (greases.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "greases" */ "../views/GreasesView.vue"),
  },
  {
    path: "/products/quality-control",
    name: "quality-control",
    // route level code-splitting
    // this generates a separate chunk (quality-control.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "quality-control" */ "../views/QualityControlView.vue"
      ),
  },
  {
    path: "/careers",
    name: "careers",
    // route level code-splitting
    // this generates a separate chunk (careers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "careers" */ "../views/CareersView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    // route level code-splitting
    // this generates a separate chunk (contact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
  },

  // {
  //   path: "/blog/",
  //   name: "blog-home",
  //   component: BlogHome,
  // },
  // {
  //   path: "/blog/:slug",
  //   name: "blog-post",
  //   component: BlogPost,
  // },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    // route level code-splitting
    // this generates a separate chunk (not-found.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "not-found" */ "../components/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
